// Ajusta a tu dominio/base
const apiUrl = 'https://api.packingapp.cl';
export default apiUrl;
